import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HttpService } from './http.service';
import { environment } from './../../environments/environment';

@Injectable()
export class GDPRService {
  constructor(public httpService: HttpService, public router: Router) { }
  private tokenPrefix = 'Bearer ';
  private gToken: string;
  private zToken: string;
  private getHeader(token) {
    return this.httpService.getHeader(this.tokenPrefix, token);
  }

  public getUserStatus() {
    return this.httpService.doGet(`${environment.gdprUrl}/status`, this.getHeader(this.zToken));
  }
  public getExchangedToken(type, id) {
    return this.httpService.doGet(`${environment.gdprUrl}/token/exchange/${type}/${id}`, this.getHeader(this.gToken));
  }

  public getUserData() {
    return this.httpService.doGet(`${environment.gdprUrl}/complianceInfo`, this.getHeader(this.zToken));
  }

  public removeUserData() {
    return this.httpService.doGet(`${environment.gdprUrl}/optOut`, this.getHeader(this.zToken));
  }

  public emailReport(payload) {
    return this.httpService.doPost(`${environment.gdprUrl}/email`, payload, this.getHeader(this.zToken));
  }

  public setZToken(token) {
    this.zToken = token;
  }

  public setGToken(token) {
    this.gToken = token;
  }

  public getZToken() {
    return this.zToken;
  }

  public getGToken() {
    return this.gToken;
  }

  public getRecaptchaKey() {
    return `${environment.siteKey}`;
  }

  public getSplOptoutUrl() {
    return `https://spl.zeotap.com/?env=mWeb&zdid=0&optin=yes&cookieSync=false&token=${encodeURIComponent(encodeURIComponent(this.getZToken()))}&zurl=${encodeURIComponent(`${environment.gdprUrl}/webOptout?{ALL_PARAMS}`)}`;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/gdpr.service.ts